import moment from 'moment';
import 'moment/locale/et';

export function formatFromNow(date, locale = 'en') {
  if (!date) return '';
  return moment(date).locale(locale).fromNow();
}
